module.exports = __webpack_public_path__ + "static/images/add.22049c59ba87143ee92acaaabad727bb.svg";